module.exports = __webpack_public_path__ + "img/big-data.e16a4d19.png";